import React from "react";
import Header from './components/Header';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainContent from "./components/MainContent";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<MainContent />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}
export default App;